import {
  Box,
  Button,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { TabInfo, Tabs } from 'shared/ui/tabs';
import MediaSuppliersPrices from 'features/prices/media-suppliers-prices';
import { MediaBasicDataCard } from 'features/media/basic-data-card/media-basic-data-card';
import { useMemo, useState } from 'react';
import MediaSuppliersArchivePrices from 'features/prices/media-suppliers-archive-prices';
import { AddCompanyDialog } from 'components/Companies/CompanyDialog/company-dialog.add';
import { CreateCompanyDto } from '@sr/dto';
import { companyApi } from 'entities/company/details/api';
import { useSnack } from 'shared/ui/snack';
import { useAddMediaPrice } from 'entities/media/media-price/hook';

type Props = {
  mediaId: number;
}


export const MediaHomeTab = ({ mediaId }: Props) => {
  const [isAddCompanyDialogOpen, setAddCompanyDialogOpen] = useState(false);
  const { showSuccess, showError } = useSnack();
  const addMediaPrice = useAddMediaPrice();
  const [postCompany] = companyApi.usePostCompanyMutation();

  const tabs: TabInfo[] = useMemo(
    () =>[
      {
        label: 'Основные',
        component: <MediaSuppliersPrices mediaId={mediaId} />
      },
      {
        label: 'Архив',
        component: <MediaSuppliersArchivePrices mediaId={mediaId} />
      }
    ],
    [mediaId]
  );

  const handleAddCompany = async (companyData: CreateCompanyDto) => {
    try {
      const res = await postCompany(companyData).unwrap();
      showSuccess('Компания успешно добавлена');

      try {
        await addMediaPrice({
          companies: res.id.toString(),
          extraFiles: [],
          media: mediaId
        });
      } catch (error) {
        showError('Ошибка добавления прайса: ', error);

      }

    } catch (error) {
      showError('Ошибка добавления компании: ', error);
    }
  };

  return (
    <Box mt={2}>
      <Stack direction='row' spacing={2}>
        <Box minWidth={500}>
          <MediaBasicDataCard mediaId={mediaId} />
        </Box>

        <Box minWidth={400} flexGrow={1}>
          <Paper sx={{ p: 2 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 1 }}>
              <Typography variant='h6' color='primary'>
                Поставщики и прайсы
              </Typography>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => setAddCompanyDialogOpen(true)}
              >
                Создать фирму
              </Button>
            </Stack>
            <Tabs tabs={tabs} />
          </Paper>
        </Box>
      </Stack>
      <AddCompanyDialog
        open={isAddCompanyDialogOpen}
        onSubmit={handleAddCompany}
        onClose={() => setAddCompanyDialogOpen(false)}
      />
    </Box>

  );
};
